import { ALL_INDUSTRIES } from '@careerstart/wae-common/schema/models/position-template/enums/industries';
import { PAID_BREAK_BEHAVIORS } from '@careerstart/wae-common/schema/models/position-template/enums/paidBreakBehaviors';

export const SECTION_IDS = {
  POSITION_DETAILS: 'positionDetails',
  LOCATIONS: 'locations',
  PAY_RATES: 'payRates',
  SHIFTS: 'shifts',
  REQUIREMENTS: 'requirements',
  ADDITIONAL_INFO: 'additionalInfo',
  LEGAL_INFO: 'legalInfo',
};

export const SECTIONS = [
  {
    id: SECTION_IDS.POSITION_DETAILS,
    labelKey: 'positionTemplate.create.sections.positionDetails',
  },
  { id: SECTION_IDS.LOCATIONS, labelKey: 'positionTemplate.create.sections.locations' },
  { id: SECTION_IDS.PAY_RATES, labelKey: 'positionTemplate.create.sections.payRates' },
  { id: SECTION_IDS.SHIFTS, labelKey: 'positionTemplate.create.sections.shifts' },
  { id: SECTION_IDS.REQUIREMENTS, labelKey: 'positionTemplate.create.sections.requirements' },
  {
    id: SECTION_IDS.ADDITIONAL_INFO,
    labelKey: 'positionTemplate.create.sections.additionalInfo',
  },
  { id: SECTION_IDS.LEGAL_INFO, labelKey: 'positionTemplate.create.sections.legalInfo' },
];

export const POSITION_NAME_MAX_LENGTH = 10000;
export const DESCRIPTION_MAX_LENGTH = 100000;
export const PAY_RATE_INPUT_PATTERN = /^\d{0,5}(\.\d{0,2})?$/;
export const SHOW_BILL_RATE_NOTE = false;
export const SHIFT_NAME_MAX_LENGTH = 100;
export const DEFAULT_SHIFT_START = 420;
export const DEFAULT_SHIFT_END = 900;
export const EARLY_PUNCH_WINDOW_OPTIONS = [0, 5, 10, 15];
export const PUNCH_ROUNDING_OPTIONS = [1, 5, 10, 15];
export const MIN_PUNCH_DISTANCE = 100;
export const DEFAULT_MAX_PUNCH_DISTANCE = 200;
export const PUNCH_DISTANCE_INPUT_PATTERN = /^\d{0,6}$/;
export const INDUSTRY_OPTIONS = ALL_INDUSTRIES.map((industry) => ({
  value: industry,
  labelKey: `positionTemplate.create.positionDetails.industry.option.${industry}`,
}));
export const PAID_BREAK_OPTIONS = [
  {
    value: PAID_BREAK_BEHAVIORS.EXPECTED_30_MIN_AFTER_6H,
    labelKey: 'positionTemplate.create.legalInfo.paidBreak.option.expected30MinAfter6h',
  },
  {
    value: PAID_BREAK_BEHAVIORS.NOT_EXPECTED,
    labelKey: 'positionTemplate.create.legalInfo.paidBreak.option.notExpected',
  },
];

export const getSectionAnchorId = (sectionId) => `position-template-section-${sectionId}`;
